import { Tooltip } from '@mui/material';
import { ReactNode } from 'react';

interface TruncatedTextTooltipProps {
  children: ReactNode;
}

export default function TruncatedTextTooltip({ children }: TruncatedTextTooltipProps): JSX.Element {
  return (
    <Tooltip title={children}>
      <span className="truncate">{children}</span>
    </Tooltip>
  );
}
